
<template>
  <div id="leftSide">
    <div class="logo">
      <img :src="iconSrc" class="icon">
      <hr class="line"/>
    </div>
    <p>Communicate in Harmony</p>
  </div>
</template>

<script>

export default {
  name: 'LeftSide',
  data () {
    return {
    }
  },
  computed: {
    iconSrc () {
      return require('../assets/maestro.svg')
    }
  }
}
</script>
